export default __webpack_public_path__ + "static/FrontDesk-c9244396b068c06216baf93c2cc98ffb.svg";